import $ from 'jquery';
import React, { Component } from 'react';
import autobind from 'class-autobind';
import classNames from 'classnames';

import map from 'lodash/map';
import noop from 'lodash/noop';
import isArray from 'lodash/isArray';
import debounce from 'lodash/debounce';

import { isVideoish } from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';


class SlideshowThumbnailsNav extends Component {

  constructor() {
    super();

    this.state = {
      currentRange: []
    };

    autobind(this);
  }

  componentDidMount() {
    // allow the parent slideshow to call methods on this child
    if (this.props.tellRef) {
      this.props.tellRef(this);
    }

    $(window).on('resize.slideshowThumbnails', debounce(() => {
      this.setThumbnailsViewportRangeForSlideIndex(this.getThumbnailsViewportRangeForSlideIndex());
    }, 100));
  }

  componentWillUnmount() {
    // remove the parent's ref to the child
    if (this.props.tellRef) {
      this.props.tellRef(undefined);
    }

    $(window).off('resize.slideshowThumbnails');
  }

  componentDidUpdate(prevProps) {
    this.updateSliderTotalWidth();

    // nothing happend so don't move the thumbnail display
    if (prevProps.currentSlideIdx === this.props.currentSlideIdx) {
      return;
    }

    this.determineThumbnailsDisplayFromCurrentSlideIdx(
      prevProps.currentSlideIdx,
      this.props.currentSlideIdx
    );
  }

  getThumbnailOuterWidth() {
    return $(this.galleriaThumbnailsRef).find('.galleria-image').outerWidth(true);
  }

  getTotalSliderWidth() {
    return this.props.contentItems.length * (this.getThumbnailOuterWidth());
  }

  getDisplayableWidth() {
    return $(this.galleriaThumbnailsRef).parent().width();
  }

  getNumberOfVisibleThumbnails() {
    return Math.floor(this.getDisplayableWidth() / this.getThumbnailOuterWidth());
  }

  determineThumbnailsDisplayFromCurrentSlideIdx(oldCurrentSlideIdx, newCurrentSlideIdx) {
    // based on the previous slideIdx and the new slideIdx, we decide if we
    // update the range to either increment or decrement the viewport

    const { currentSlideIdx, contentItems } = this.props;

    // we're at the beginning, don't do anything
    if (currentSlideIdx === 0) {
      return;
    }

    // we're at the end, don't do anything
    if (currentSlideIdx === contentItems.length - 1) {
      return;
    }

    // we moved forward one slide
    if (oldCurrentSlideIdx === newCurrentSlideIdx - 1) {

      this.setState((prevState) => {
        const [lowestIdx, highestIdx] = prevState.currentRange;

        if (currentSlideIdx >= highestIdx) {
          this.animateThumbnails(lowestIdx + 1);
          return { currentRange: [lowestIdx + 1, highestIdx + 1] };
        }
        return { currentRange: prevState.currentRange };
      });

    // we moved backward one slide
    } else if (oldCurrentSlideIdx === newCurrentSlideIdx + 1) {

      this.setState((prevState) => {
        const [lowestIdx, highestIdx] = prevState.currentRange;

        if (currentSlideIdx <= lowestIdx) {
          this.animateThumbnails(lowestIdx - 1);
          return { currentRange: [lowestIdx - 1, highestIdx - 1] };
        }
        return { currentRange: prevState.currentRange };
      });
    
    }
  }

  setThumbnailsViewportRangeForSlideIndex(newRange) {
    if (isArray(newRange) && newRange.length !== 2) {
      throw new Error('setThumbnailsViewportRangeForSlideIndex expects "newRange" to be an array with a starting index and ending index');
    }

    this.animateThumbnails(newRange[0]);
    this.setState({ currentRange: newRange });
  }

  animateThumbnails(offset=0) {
    // no need for animation
    if (this.props.contentItems.length <= this.getNumberOfVisibleThumbnails()) {
      return;
    }

    $(this.galleriaThumbnailsRef).animate({
      marginLeft: `-${offset * this.getThumbnailOuterWidth()}`
    }, 500);
  }

  getThumbnailsViewportRangeForSlideIndex() {
    const { currentSlideIdx } = this.props;
    const numberOfVisibleThumbnails = this.getNumberOfVisibleThumbnails();

    // if the slide number is less than the max visible then we start the range at 0
    if (currentSlideIdx < numberOfVisibleThumbnails) {
      return [0, numberOfVisibleThumbnails - 1];
    }

    // otherwise we need to calculate the range where the current slide is the the last item
    return [currentSlideIdx - numberOfVisibleThumbnails + 1, currentSlideIdx];
  }

  updateSliderTotalWidth() {
    $(this.galleriaThumbnailsRef).css({
      overflow: 'hidden',
      position: 'relative',
      width: this.getTotalSliderWidth()
    });
  }

  handleGalleriaThumbnailsRefReceived(galleriaThumbnailsRef) {
    this.galleriaThumbnailsRef = galleriaThumbnailsRef;

    this.updateSliderTotalWidth();

    const initialRange = this.getThumbnailsViewportRangeForSlideIndex(); 

    this.setState({ currentRange: initialRange });

    this.animateThumbnails(initialRange[0]);
  }

  handlePreviousThumbnailsClick() {
    const lowestIdx = this.state.currentRange[0];
    const numberOfVisibleThumbnails = this.getNumberOfVisibleThumbnails();

    let newLowestIdx = lowestIdx - numberOfVisibleThumbnails;

    if (newLowestIdx < 0) {
      newLowestIdx = 0;
    }

    const newHighestIdx = newLowestIdx + numberOfVisibleThumbnails - 1;

    this.setThumbnailsViewportRangeForSlideIndex([newLowestIdx, newHighestIdx]);
  }

  handleNextThumbnailsClick() {
    const { contentItems } = this.props;
    const highestIdx = this.state.currentRange[1];
    const numberOfVisibleThumbnails = this.getNumberOfVisibleThumbnails();

    let newHighestIdx = highestIdx + numberOfVisibleThumbnails;

    if (newHighestIdx > contentItems.length - 1) {
      newHighestIdx = contentItems.length - 1;
    }

    const newLowestIdx = newHighestIdx - numberOfVisibleThumbnails + 1;

    this.setThumbnailsViewportRangeForSlideIndex([newLowestIdx, newHighestIdx]);
  }

  render() {
    const { contentItems, currentSlideIdx, onThumbnailClick, SlideshowThumbnailComponent } = this.props;

    const [lowestIdx, highestIdx] = this.state.currentRange;

    const numberOfVisibleThumbnails = this.getNumberOfVisibleThumbnails();
    const isNavigationVisble = numberOfVisibleThumbnails < contentItems.length - 1;
    const isPreviousArrowDisabled = lowestIdx === 0;
    const isNextArrowDisabled = highestIdx === contentItems.length - 1;

    return (
      <div className="galleria-thumbnails-container">

        <div
          style={{
            display: isNavigationVisble ? 'block' : 'none'
          }}
          onClick={isPreviousArrowDisabled ? noop : this.handlePreviousThumbnailsClick}
          className={classNames('galleria-thumb-nav-left', {
            disabled: isPreviousArrowDisabled
          })}
        />

        <div className="galleria-thumbnails-list">
          <div className="galleria-thumbnails" ref={this.handleGalleriaThumbnailsRefReceived}>
            {
              map(contentItems, (contentItem, idx) => (
                <SlideshowThumbnailComponent
                  key={contentItem.eid || contentItem.uuid}
                  uuid={contentItem.uuid}
                  isVideo={isVideoish(contentItem)}
                  isActive={currentSlideIdx === idx}
                  contentItem={contentItem}
                  onClick={() => { onThumbnailClick(idx); }}
                />
              ))
            }
          </div>
        </div>

        <div
          style={{
            display: isNavigationVisble ? 'block' : 'none'
          }}
          onClick={isNextArrowDisabled ? noop : this.handleNextThumbnailsClick}
          className={classNames('galleria-thumb-nav-right', {
            disabled: isNextArrowDisabled
          })}
        />

      </div>
    );
  }

}

export default SlideshowThumbnailsNav;
